const RECENT_SEARCHES_ID = 'recent-searches-section';

document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('predictive-search-input');
  const resultsContainer = document.getElementById('predictive-search-results');
  const loadingIndicator = document.getElementById('predictive-search-loading');
  const idleRegions = document.querySelectorAll('[data-search-modal-idle]');
  const bestSellers = document.querySelector('[data-search-modal-best-sellers]');

  if (!input || !resultsContainer) return;

  let debounceTimer = null;
  let abortController = null;

  const toggle = (element, isHidden) => {
    element?.classList.toggle('hidden', isHidden);
  };

  const showLoading = () => {
    resultsContainer.classList.add('hidden');
    idleRegions.forEach((region) => toggle(region, true));
    toggle(bestSellers, true);
    if (loadingIndicator) {
      loadingIndicator.classList.remove('hidden');
      loadingIndicator.classList.add('flex');
    }
  };

  // Single source of truth for the three-state modal: idle, results, empty.
  const applyState = (state) => {
    if (loadingIndicator) {
      loadingIndicator.classList.add('hidden');
      loadingIndicator.classList.remove('flex');
    }

    const isIdle = state === 'idle';
    toggle(resultsContainer, isIdle);
    toggle(bestSellers, state === 'results');

    idleRegions.forEach((region) => {
      // Recent searches owns its own visibility — it must stay hidden when
      // there is no stored history, so returning to idle re-runs its render
      // instead of blindly unhiding an empty region.
      if (isIdle && region.id === RECENT_SEARCHES_ID) return;
      toggle(region, !isIdle);
    });

    if (isIdle) {
      resultsContainer.innerHTML = '';
      window.searchRecentSearches?.renderRecentSearches();
    }
  };

  const performSearch = async (query) => {
    if (abortController) abortController.abort();
    abortController = new AbortController();

    showLoading();

    const root = window.Shopify?.routes?.root || '/';
    const { sectionId } = input.dataset;
    const url = `${root}search?q=${encodeURIComponent(query)}&type=product&options[prefix]=last&section_id=${sectionId}`;

    try {
      const response = await fetch(url, { signal: abortController.signal });

      if (!response.ok) throw new Error('Search failed');

      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      const sectionContent = doc.getElementById('search-modal-section-results');

      if (!sectionContent) {
        applyState('idle');
        return;
      }

      // Read the state before injecting — innerHTML discards the fetched root.
      const state = sectionContent.dataset.searchState || 'idle';
      resultsContainer.dataset.searchState = state;
      resultsContainer.innerHTML = sectionContent.innerHTML;
      applyState(state);
    } catch (error) {
      if (error.name !== 'AbortError') applyState('idle');
    }
  };

  const debounce = (fn, delay) => {
    return (...args) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => fn(...args), delay);
    };
  };

  const debouncedSearch = debounce((query) => {
    if (query.length >= 2) performSearch(query);
  }, 300);

  input.addEventListener('input', () => {
    const query = input.value.trim();

    if (query.length < 2) {
      clearTimeout(debounceTimer);
      abortController?.abort();
      applyState('idle');
      return;
    }

    debouncedSearch(query);
  });

  input.addEventListener('keydown', (e) => {
    const query = input.value.trim();

    if (e.key === 'Enter' && query) {
      window.searchRecentSearches?.trackSearch(query);
      const root = window.Shopify?.routes?.root || '/';
      window.location.href = `${root}search?q=${encodeURIComponent(query)}&type=product`;
    }
  });

  window.predictiveSearch = { applyState };
});
